const app = {
  state: {
    VLanguage: localStorage.VLanguage || 'el-GR',
    language: localStorage.appLanguage || 'gr',
    primaryColor: localStorage.appPrimaryColor || '#03a8fc',
    secondaryColor: localStorage.appSecondaryColor || '#104e7f',
    userDashboardSettings: {
      user: {
        components: [
          {
            table: 'TrainingMaterial',
            label: 'b2b_training_material',
            link: 'training_material'
          },
          { table: 'genericTable', label: 'b2b_posts', link: 'posts' }
        ]
      },
      'greg-user': {
        components: [
          {
            table: 'TrainingMaterial',
            label: 'b2b_training_material',
            link: 'training_material'
          },
          { table: 'genericTable', label: 'b2b_posts', link: 'posts' }
        ]
      },
      store_manager: {
        components: [
          {
            table: 'TrainingMaterial',
            label: 'b2b_training_material',
            link: 'training_material'
          },
          { table: 'genericTable', label: 'b2b_posts', link: 'posts' }
        ]
      },
      trainee: {
        components: [
          {
            table: 'TrainingMaterial',
            label: 'b2b_training_material',
            link: 'training_material'
          }
        ]
      },
      franchisee: {
        components: [
          { table: 'genericTable', label: 'b2b_posts', link: 'posts' }
        ]
      }
    }
  },
  mutations: {
    SET_LANGUAGE: (state, language) => {
      var lng;
      switch (language) {
        case 'en':
          lng = 'en-US';
          break;
        case 'gr':
          lng = 'el-GR';
          break;
        case 'fr':
          lng = 'fr-FR';
          break;
        default:
          lng = 'en-US';
      }
      state.language = language;
      state.VLanguage = lng;
      localStorage.setItem('VLanguage', lng);
      localStorage.setItem('appLanguage', language);
      // location.reload()
    },
    SET_PRIMARY_COLOR: (state, primaryColor) => {
      if (primaryColor) {
        state.primaryColor = primaryColor;
        localStorage.setItem('appPrimaryColor', primaryColor);
        // console.log(state.primaryColor)
      }
    },
    SET_SECONDARY_COLOR: (state, secondaryColor) => {
      if (secondaryColor) {
        state.secondaryColor = secondaryColor;
        localStorage.setItem('appSecondaryColor', secondaryColor);
        // console.log(state.secondaryColor)
      }
    }
  },
  actions: {
    setLanguage({ commit }, language) {
      commit('SET_LANGUAGE', language);
    },
    setPrimaryColor({ commit }, primaryColor) {
      commit('SET_PRIMARY_COLOR', primaryColor);
    },
    setSecondaryColor({ commit }, secondaryColor) {
      commit('SET_SECONDARY_COLOR', secondaryColor);
    }
  },
  getters: {
    getMyLang: state => state.language,
    primaryColorGetter: state => state.primaryColor,
    secondaryColor: state => state.secondaryColor,
    userDashboardSettingsGetter: state => state.userDashboardSettings
  }
};

export default app;



// WEBPACK FOOTER //
// ./src/store/modules/app.js